import { serviceApi } from '~/api/service';

export const shopsUrl = (string) => `stores${string}`;

export const shopsApi = {
  fetch: (url, options, bypassErrorCodes = []) =>
    serviceApi.fetchJSON(shopsUrl(url), options, undefined, bypassErrorCodes),
};
